import { render, staticRenderFns } from "./dispatchGuide.vue?vue&type=template&id=1bc04fb0&scoped=true&"
import script from "./dispatchGuide.vue?vue&type=script&lang=js&"
export * from "./dispatchGuide.vue?vue&type=script&lang=js&"
import style0 from "./dispatchGuide.vue?vue&type=style&index=0&id=1bc04fb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc04fb0",
  null
  
)

export default component.exports